import React from 'react';
import Image from '@sls-react/components/Image';
import ArrowRightIcon from '@sls-react/static/svg/ArrowRightIcon';
import classNames from 'classnames';

interface Props {
  className?: any;
  image?: string;
  onClick?: React.MouseEventHandler;
  title: string;
}

const UnlimitedTileBase: React.FC<Props> = ({
  className,
  image,
  onClick,
  title,
}) => (
  <button
    className={classNames(
      'p-2 border rounded shadow md:flex w-full md:items-center md:px-4 border-grey-200 hover:shadow-md transition-shadow duration-300',
      className,
    )}
    onClick={onClick}
  >
    {image ? (
      <Image
        alt=""
        src={image}
        className="block object-cover w-16 h-16 mx-auto rounded-full md:w-6 md:h-6 md:ml-0 md:mr-4"
      />
    ) : (
      <div className="w-16 h-16 md:w-6 md:h-6 md:ml-0 md:mr-4" />
    )}

    <div className="block mt-2 text-sm font-semibold text-center md:text-left md:mt-0">
      {title}
    </div>

    <div className="md:mr-auto" />

    <ArrowRightIcon className="hidden md:block" />
  </button>
);

export default UnlimitedTileBase;
